const ImagesRoute = {
  myImg: require("./images/myImg.png"),
  SSlog: require("./images/SSlog.png"),
  NNlog: require("./images/NNlog.png"),
  IMG_6728: require("./images/IMG_6728.jpg"),
  IMG_3975: require("./images/IMG_3975.jpg"),
  IMG_6732: require("./images/IMG_6732.jpg"),
  IMG_1782: require("./images/IMG_1782.jpg"),
  so: require("./images/so.png"),
  so1: require("./images/so1.png"),
  yuragi: require("./images/yurgi.png"),
  react_ico: require("./images/react_ico.png"),
  go_ico: require("./images/go_ico.png"),
  NET_icon: require("./images/NET_icon.png"),
  gp83: require("./images/gp83.png"),
  manaphoto: require("./images/manaphoto.png"),
  IMG_5658: require("./images/IMG_5658.jpeg"),
  haryhi1: require("./images/haryhi1.jpeg"),
  haruhi2: require("./images/haruhi2.jpeg"),
  IMG_2839: require("./images/IMG_2839.jpg"),
  IMG_1347: require("./images/IMG_1347.jpg"),
  IMG_2122: require("./images/IMG_2122.jpg"),
  IMG_152: require("./images/IMG_152.jpg"),
  scs: require("./images/scs.png"),
  outfitw: require("./images/outfitw.png"),
  manamisky: require("./images/manamisky.jpg"),
  dawn: require("./images/dawn.png"),
  outfitgamen: require("./images/outfitgamen.png"),
  manamisorami1: require("./images/manamisorami1.jpg"),
  outfitmain: require("./images/outfitmain.png"),
  manamisorami2: require("./images/manamisorami2.jpg"),
  Blender_23505: require("./images/Blender_23505.png"),
  file_type_python_icon_130221: require("./images/file_type_python_icon_130221.png"),
  laravel_icon: require("./images/laravel_icon.png"),
  S__111206405: require("./images/S__111206405.jpg"),
  dawn_cat: require("./images/dawn_cat.png"),
  dawn_cat_ani: require("./images/dawn_cat_ani.png"),
  dawn_cat_ani2: require("./images/dawn_cat_ani2.png"),
  MePhoto: require("./images/MePhoto.jpg"),
  MePhoto2: require("./images/MePhoto2.jpg"),
  code: require("./images/code.png"),
  design: require("./images/design.png"),
  photo: require("./images/photo.png"),
  openButton: require("./images/openButton.png"),
  matitaka_wh: require("./images/matitaka-wh.png"),
  manami_hydoro: require("./images/manami_hydoro.png"),
  IMG144: require("./images/IMG144.jpg"),
  IMG145: require("./images/IMG145.jpg"),
  IMG147: require("./images/IMG147.jpg"),
  arrow: require("./images/arrow.png"),
  IMG_1417: require("./images/IMG_1417.jpg"),

  IMG_7112: require("./images/photos/IMG_7112.jpg"),
  IMG_7157: require("./images/photos/IMG_7157.jpg"),
  IMG_7169: require("./images/photos/IMG_7169.jpg"),
  IMG_7174: require("./images/photos/IMG_7111.jpg"),
  IMG_7146: require("./images/photos/IMG_7146.jpg"),

  IMG_7120: require("./images/photos/IMG_7120.jpg"),
  IMG_7182: require("./images/photos/IMG_7182.jpg"),
  IMG_7185: require("./images/photos/IMG_7185.jpg"),
  IMG_7391: require("./images/photos/IMG_7391.jpg"),
  IMG_7398: require("./images/photos/IMG_7398.jpg"),

  netmaui: require("./images/.netmaui.png"),
  csharp: require("./images/cs.png"),
  cpp: require("./images/cpp.png"),
  css: require("./images/css.png"),
  go: require("./images/go.png"),
  html: require("./images/html.png"),
  java: require("./images/java.png"),
  js: require("./images/js.png"),
  laravel: require("./images/laravel.png"),
  mysql: require("./images/mysql.png"),
  php: require("./images/php.png"),
  python: require("./images/python.png"),
  react: require("./images/react.png"),
  ubuntu: require("./images/ubuntu.png"),
  xaml: require("./images/xaml.png"),
  xml: require("./images/xml.png"),
  tailwind: require("./images/tailwind.png"),
  node: require("./images/node.png"),
  arduino: require("./images/arduino.png"),
  me: require("./images/me.jpg"),

  logis_icon: require("./images/Logis_icon.png"),
  logis_ap: require("./images/logis_ap.png"),
  logis_sc1: require("./images/logis-sc1.png"),
  logis_sc2: require("./images/logis-sc2.png"),
  logis_sc3: require("./images/logis-sc3.png"),
  table_5356682_1920: require("./images/table-5356682_1920.jpg"),
  chronodawn_log: require("./images/chronodawn_log.png"),

  //material
  i1516528960: require("./images/materials/1516528960.png"),
  net_icno: require("./images/materials/net_icon.png"),
  server_icon: require("./images/materials/server_icon.png"),
  ckeck: require("./images/materials/ckeck.png"),
  mainasu: require("./images/materials/mainasu.png"),
  tilekku: require("./images/materials/tilekku.png"),
  gan: require("./images/materials/9.jpg"),
  content1: require("./images/materials/content1.png"),
  content2: require("./images/materials/content2.png"),
  framer_logo: require("./images/materials/framer_logo_icon_169149.png"),
  adobefonts: require("./images/materials/adobefonts.png"),
  core: require("./images/materials/core.png"),
  xd: require("./images/materials/xd.png"),
  lightroom: require("./images/materials/lightroom.png"),
  photoshop: require("./images/materials/photoshop.png"),
  excel: require("./images/materials/excel.png"),
  fonts: require("./images/materials/adobefonts.png"),
  adobeexpress: require("./images/materials/adobeexpress.png"),
  IMG_7009: require("./images/IMG_7009-Enhanced-NR.jpg"),
  IMG_7017: require("./images/photos/IMG_7017.jpg"),
  IMG_7018: require("./images/IMG_7018.jpg"),
  IMG_7033: require("./images/IMG_7033.jpg"),
  IMG_7034: require("./images/IMG_7034.jpg"),
  IMG_7035: require("./images/IMG_7035.jpg"),
  IMG_7037: require("./images/IMG_7037.jpg"),
  IMG_7038: require("./images/IMG_7038.jpg"),
  IMG_7039: require("./images/IMG_7039.jpg"),
  IMG_7041: require("./images/IMG_7041.jpg"),
  IMG_7043: require("./images/IMG_7043.jpg"),
  IMG_7048: require("./images/IMG_7048.jpg"),
  IMG_7050: require("./images/IMG_7050.jpg"),
  IMG_7052: require("./images/IMG_7052.jpg"),
  IMG_7053: require("./images/IMG_7053.jpg"),
  IMG_7028: require("./images/IMG_7028.jpg"),

  p20240705_Manami_Sorami_152: require("./images/photos/20240705_Manami_Sorami-152.jpg"),
  IMG_7061: require("./images/photos/IMG_7061.jpg"),
  IMG_7062: require("./images/photos/IMG_7062.jpg"),
  IMG_7063: require("./images/photos/IMG_7063.jpg"),
  IMG_7064: require("./images/photos/IMG_7064.jpg"),
  IMG_7065: require("./images/photos/IMG_7065.jpg"),
  IMG_7066: require("./images/photos/IMG_7066.jpg"),
  IMG_7067: require("./images/photos/IMG_7067.jpg"),
  IMG_7068: require("./images/photos/IMG_7068.jpg"),
  IMG_7069: require("./images/photos/IMG_7069.jpg"),

  material_web: require("./images/materials/material_web.png"),
  material_spa: require("./images/materials/material_spa.png"),

  logo_winui: require("./images/photos/logo-winui.png"),
  MAUI: require("./images/photos/MAUI.png"),
  under_line: require("./images/photos/under_line.png"),
  under_write: require("./images/photos/under_write.png"),
  write: require("./images/photos/write.png"),
  write_logo: require("./images/photos/write_logo.png"),
  ss: require("./images/photos/ss.png"),
  dawn_wander_tec: require("./images/photos/dawn_wander_tec.png"),

  framer_motion: require("./images/icons/framer-motion.png"),

  table_5356682_1920: require("./images/materials/table-5356682_1920.jpg"),
  p464739458_416156958199650_3162208171733525292_n: require("./images/materials/464739458_416156958199650_3162208171733525292_n.jpg"),
  IMG_2855: require("./images/materials/IMG_2855.jpg"),

  dining_table_7782610_1920: require("./images/materials/dining-table-7782610_1920.jpg"),
  t_ed_hOgog7l_iuY_unsplash: require("./images/materials/t-ed-hOgog7l-iuY-unsplash.jpg"),
  hermes_rivera_aK6WGqxyHFw_unsplash: require("./images/materials/hermes-rivera-aK6WGqxyHFw-unsplash.jpg"),

  p465189818_3939773542908699_8873408741192309513_n: require("./images/materials/465189818_3939773542908699_8873408741192309513_n.jpg"),
  p465523955_568969585623225_5011903062634586769_n: require("./images/materials/465523955_568969585623225_5011903062634586769_n.jpg"),
  p465072607_1461049087899559_588075790240556776_n: require("./images/materials/465072607_1461049087899559_588075790240556776_n.jpg"),

  IMG_2882: require("./images/materials/IMG_2882.jpg"),
  IMG_8332: require("./images/materials/IMG_8332.png"),
  IMG_7856: require("./images/materials/IMG_7856.png"),

  guid: require("./images/materials/guid.png"),
  guid2: require("./images/materials/guid2.png"),
  github_icon: require("./images/materials/github-logo_icon-icons.com_73546.png"),

  menu_bar: require("./images/icons/menu_bar.png"),
  volumeanalyzer: require("./images/icons/volumeanalyzer.png"),
  audioanalyzer_icon: require("./images/icons/audioanalyzer_icon.png"),
  home_icon: require("./images/icons/home_icon.png"),
  pixcelanalyzer_icon: require("./images/icons/pixcelanalyzer_icon.png"),

  Audioroutine_icon: require("./images/icons/Audioroutine_icon.png"),
  powersupply_icon: require("./images/icons/powersupply_icon.png"),
  sangira_icon: require("./images/icons/sangira_icon.png"),
  sangria_img: require("./images/photos/sangria_img.png"),
  rumos_ts: require("./images/photos/rumos_ts.png"),

  sangria_phooto_1: require("./images/photos/sangria_phooto-1.jpg"),
  sangria_phooto_2: require("./images/photos/sangria_phooto-2.jpg"),
  sangria_phooto_3: require("./images/photos/sangria_phooto-3.jpg"),
  sangria_phooto_4: require("./images/photos/sangria_phooto-4.jpg"),
  sangria_phooto_5: require("./images/photos/sangria_phooto-5.jpg"),
  sangria_phooto_6: require("./images/photos/sangria_phooto-6.jpg"),
  sangria_phooto_7: require("./images/photos/sangria_phooto-7.jpg"),
  sangria_phooto_8: require("./images/photos/sangria_phooto-8.jpg"),

  duskOwl_flaing: require("./images/photos/DuskOwl_flaing.png"),
  IMG_0168: require("./images/photos/IMG_0168.jpg"),

  //Dayoff素材
  carnav_photo: require("./images/materials/carnav_photo.png"),
  dayoff_tecnorogy: require("./images/materials/dayoff_tecnorogy.png"),
  bubble: require("./images/materials/bubble.png"),
  DayoffWhiteLogo: require("./images/materials/DayoffWhiteLogo.png"),
  jumbubblelogo: require("./images/materials/jumbubblelogo.png"),
  night_view: require("./images/materials/night_view.jpg"),
  pexels_thevibrantmachine_3066867: require("./images/materials/pexels-thevibrantmachine-3066867.jpg"),
  example_dayoff2: require("./images/materials/example_dayoff2.png"),
  ruizi_1: require("./images/materials/ruizi_1.png"),
  ruizi_2: require("./images/materials/ruizi_2.png"),
  ruizi_3: require("./images/materials/ruizi_3.jpg"),
  example_dayoff: require("./images/materials/example_dayoff.png"),

  download_icon: require("./images/icons/download.png"),
  screen_share: require("./images/icons/screen-share.png"),
};

export default ImagesRoute;
